import Button from 'base-components/Button'
import classNames from 'classnames'
import { useScene } from 'providers/SceneProvider'
import React from 'react'
import { NavLink } from 'react-router-dom'
import SlideItemData from './SlideItemData'

interface SceneSideBarProps {
  className?: string
}

const SceneSideBar: React.FC<SceneSideBarProps> = ({ className }) => {
  const { selectedSlide, deselectSlide } = useScene()

  return (
    <div
      className={classNames(['relative w-[500px] flex flex-col justify-between bg-white h-full border-l-[1px] overflow-auto', className])}
    >
      <SlideItemData slide={selectedSlide} id={'sideBarGallery'} />
      <div className='w-full flex justify-center items-center p-4'>
        {selectedSlide.id !== 'norrköping' && <Button onClick={deselectSlide}>Stäng</Button>}
        {selectedSlide.id === 'norrköping' && (
          <NavLink to='/'>
            <Button>Till startmenyn</Button>
          </NavLink>
        )}
      </div>
    </div>
  )
}

export default SceneSideBar
